import React from "react";
import PropTypes from "prop-types";
import style from "./burger-menu-country-selector-menu.css";
import analytics from "analytics/analytics";
import requester from "modules/requester";
import BurgerMenuItem from "../burger-menu-item/burger-menu-item";
import BurgerMenuSecondaryHeader from "../burger-menu-secondary-header/burger-menu-secondary-header";

function BurgerMenuCountrySelectorMenu({
    allCountries,
    currentCountry,
    currentCurrency,
    onBackToMainClick
}) {
    function onCountryClick(countryCode, newCountry) {
        analytics.event(
            "SETTINGS",
            "CHANGE_COUNTRY",
            currentCountry + "-to-" + newCountry
        );
        requester("/account/set_country/", {
            method: "POST",
            body: { country: countryCode },
            headers: {
                Accept: "text/html"
            }
        }).then(function() {
            window.location.reload(true);
        });
    }

    let countrySelection = allCountries.map((countryTuple, index) => {
        return (
            <BurgerMenuItem
                key={index}
                renderText={countryTuple[1]}
                onClickEvent={() =>
                    onCountryClick(countryTuple[0], countryTuple[1])
                }
            />
        );
    });

    return (
        <div>
            <BurgerMenuSecondaryHeader
                renderText="Country or Region"
                onClickEvent={onBackToMainClick}
            />
            <div className={style.selectedCountry}>
                Country & Shipping: {currentCountry} - {currentCurrency}
            </div>
            <ul id="countryMenuLinks">{countrySelection}</ul>
        </div>
    );
}

export default BurgerMenuCountrySelectorMenu;

BurgerMenuCountrySelectorMenu.propTypes = {
    allCountries: PropTypes.array,
    currentCountry: PropTypes.string,
    currentCurrency: PropTypes.string,
    onBackToMainClick: PropTypes.func.isRequired
};

BurgerMenuCountrySelectorMenu.defaultProps = {
    menuData: [],
    currentCountry: "",
    currentCurrency: ""
};
